// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7859f0f8306af20a","8495":"29d75c63008a2d8b"}[chunkId] + ".css";
};